// components/Calendar/CalendarModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const CalendarModal = ({ show, onHide, session, onAddToCalendar }) => {
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-calendar-plus me-2"></i>
          Add to Calendar
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {/* Session Summary */}
        <div className="mb-4">
          <h6 className="mb-2">Session Details:</h6>
          <div className="bg-light p-3 rounded">
            <p className="mb-1">
              <strong>Title:</strong> {session.title || `Session with ${session.tutorName || 'Tutor'}`}
            </p>
            <p className="mb-1">
              <strong>Date:</strong> {formatDate(session.scheduledDate)}
            </p>
            <p className="mb-1">
              <strong>Time:</strong> {session.scheduledTime} - {session.scheduledEndTime}
            </p>
            {session.subject && (
              <p className="mb-0">
                <strong>Subject:</strong> {session.subject}
              </p>
            )}
          </div>
        </div>

        {/* Calendar Options */}
        <h6 className="mb-3">Choose your calendar:</h6>
        
        <div className="calendar-options">
          {/* Google Calendar */}
          <Button 
            variant="outline-danger" 
            className="w-100 mb-2 d-flex align-items-center justify-content-start"
            onClick={() => onAddToCalendar('google')}
          >
            <div className="calendar-icon me-3">
              <i className="fab fa-google fa-lg"></i>
            </div>
            <div className="text-start">
              <div className="fw-bold">Google Calendar</div>
              <small className="text-muted">Opens in new window</small>
            </div>
          </Button>

          {/* Outlook Calendar */}
          <Button 
            variant="outline-success" 
            className="w-100 mb-2 d-flex align-items-center justify-content-start"
            onClick={() => onAddToCalendar('outlook')}
          >
            <div className="calendar-icon me-3">
              <i className="fab fa-microsoft fa-lg"></i>
            </div>
            <div className="text-start">
              <div className="fw-bold">Microsoft Outlook</div>
              <small className="text-muted">Office 365 & Outlook.com</small>
            </div>
          </Button>

          {/* Yahoo Calendar */}
          <Button 
            variant="outline-primary" 
            className="w-100 mb-2 d-flex align-items-center justify-content-start"
            onClick={() => onAddToCalendar('yahoo')}
          >
            <div className="calendar-icon me-3">
              <i className="fab fa-yahoo fa-lg"></i>
            </div>
            <div className="text-start">
              <div className="fw-bold">Yahoo Calendar</div>
              <small className="text-muted">Yahoo Mail users</small>
            </div>
          </Button>

          {/* Apple Calendar */}
          <Button 
            variant="outline-dark" 
            className="w-100 mb-2 d-flex align-items-center justify-content-start"
            onClick={() => onAddToCalendar('apple')}
          >
            <div className="calendar-icon me-3">
              <i className="fab fa-apple fa-lg"></i>
            </div>
            <div className="text-start">
              <div className="fw-bold">Apple Calendar</div>
              <small className="text-muted">Download iCal file</small>
            </div>
          </Button>

          {/* iCal File (for any calendar) */}
          <Button 
            variant="outline-info" 
            className="w-100 mb-2 d-flex align-items-center justify-content-start"
            onClick={() => onAddToCalendar('ical')}
          >
            <div className="calendar-icon me-3">
              <i className="fas fa-calendar-alt fa-lg"></i>
            </div>
            <div className="text-start">
              <div className="fw-bold">iCal File</div>
              <small className="text-muted">For any calendar app</small>
            </div>
          </Button>
        </div>

        {/* Note */}
        <div className="mt-3 small text-muted">
          <i className="fas fa-info-circle me-1"></i>
          The event will include session details, time, and meeting link.
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};